import React from 'react';
import { Link } from 'react-router-dom';

interface LoginHeaderProps {
  /** Optional custom text for the back link (default: "Back to Site") */
  backLinkText?: string;
  /** Optional custom destination for the back link (default: "/") */
  backLinkTo?: string;
}

/**
 * Shared header component for login screens (AdminLogin, UserLogin, etc.)
 *
 * Features:
 * - Consistent brand colors (bg-primary header matching landing page)
 * - Watercolor logo branding (matches main Navbar)
 * - Customizable back link
 * - Hover states with secondary-light color
 * - Responsive container with proper spacing
 *
 * Issue #1440 (Issue #3) - Extracted from AdminLogin and UserLogin
 * Related: Issue #1437, Issue #1336, Issue #1511
 *
 * @example
 * // Default usage (back to home)
 * <LoginHeader />
 *
 * @example
 * // Custom back link
 * <LoginHeader backLinkText="Back to Login" backLinkTo="/login" />
 */
export default function LoginHeader({
  backLinkText = "Back to Site",
  backLinkTo = "/"
}: LoginHeaderProps) {
  return (
    <nav className="bg-primary text-white shadow-lg">
      <div className="w-full px-1">
        <div className="flex items-center justify-between h-28">
          <Link to="/" className="flex items-center space-x-2">
            {/* Watercolor logo matching landing page */}
            <picture>
              <source srcSet="/logo.webp" type="image/webp" />
              <img src="/logo.png" alt="Local Artist Fairs" className="h-28 w-auto" />
            </picture>
          </Link>
          <div className="flex space-x-4">
            <Link to={backLinkTo} className="hover:text-secondary-light font-body transition-colors">
              {backLinkText}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
